export enum UsageTrackingMessageType {
  Navigation = 'Navigation',
  ElementClicked = 'ElementClicked',
  Calculation = 'Calculation',
}
